<template>
  <div class="ripeav-base">
    <rl-header />
    <div class="all">
      <router-view></router-view>
    </div>
    <rl-footer />
  </div>
</template>

<script>

  import RlHeader from "@/components/header";
  import RlFooter from "@/components/footer";
  export default {
    name: "Base",
    components: {RlFooter, RlHeader}
  }
</script>

<style scoped>
.all{
  min-height: 80vh;
}
</style>